import React from 'react';
import { X } from 'lucide-react';

interface ModalHeaderProps {
  title: string;
  onClose: () => void;
}

export const ModalHeader: React.FC<ModalHeaderProps> = ({ title, onClose }) => (
  <div className='flex justify-between p-4 border-b border-[#DEE2EF] items-center h-[60px]'>
    <span className='text-main text-[18px]'>{title}</span>
    <X
      className='cursor-pointer text-gray-500 hover:text-gray-700'
      size={24}
      onClick={onClose}
    />
  </div>
);

